module.exports = __webpack_public_path__ + "img/streamline-icon-island@450x450.9053b16f.svg";